import { MapTo } from "@adobe/aem-react-editable-components";
import { Suspense, lazy } from "react";
import Spacer from "../Spacer/Spacer";
import { RichtextProps } from "./Richtext.types";

const Richtext = lazy(() => import(/* webpackChunkName: 'richtext' */ './Richtext'));

const RichtextConfig = {
    emptyLabel: "Richtext",
    isEmpty: function (props: RichtextProps) {
        return !props || !props.text;
    },
};

const RichtextLoader = (props: RichtextProps) => {
    return (
        <Suspense fallback={< Spacer mobile={"58"} tablet={"58"} desktop={"58"} isInEditor={false} cqPath={""} />}>
            <Richtext {...props} />
        </Suspense>
    );
}

MapTo<RichtextProps>("alelo/components/content/v1/richtext")(
    RichtextLoader,
    RichtextConfig
);